import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../ui/TextField";
import DataSelect from "../../../../../ui/DataSelect";
import useRoomResourceForm from "./useRoomResourceForm";

const defaultData = {
  name: "",
  shortName: "",
  abbr: "",
  inn: "",
  region: null,
  municipal: null,
  legalAddress: "",
  postAddress: "",
  email: "",
  phones: ""
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  }
});

const AddOrganizationForm = ({ disabled, onFormChange, classes }) => {
  const [data, setData] = useState(defaultData);
  const { dataSources, getRegions, getMunicipals } = useRoomResourceForm();

  const {
    name,
    shortName,
    abbr,
    inn,
    region,
    municipal,
    legalAddress,
    postAddress,
    email,
    phones
  } = data;

  useEffect(() => {
    getRegions();
  }, []);

  useEffect(() => {
    if (region) getMunicipals(region);
  }, [region]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <TextField
        value={name}
        onChange={e => onChange("name", e.target.value)}
        label="Название"
        disabled={disabled}
        required
      />
      <TextField
        value={shortName}
        onChange={e => onChange("shortName", e.target.value)}
        label="Краткое наименование"
        disabled={disabled}
        required
      />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DataSelect
            value={region}
            onChange={value => onChange("region", value.id)}
            label="Регион"
            dataSource={dataSources.regions}
          />
        </Grid>
        <Grid item xs={6}>
          <DataSelect
            value={municipal}
            onChange={value => onChange("municipal", value.id)}
            label="МО"
            dataSource={dataSources.municipals}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={abbr}
            onChange={e => onChange("abbr", e.target.value)}
            label="Аббревиатура"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={inn}
            onChange={e => onChange("inn", e.target.value)}
            label="ИНН"
            disabled={disabled}
            required
          />
        </Grid>
      </Grid>
      <TextField
        value={legalAddress}
        onChange={e => onChange("legalAddress", e.target.value)}
        label="Юридический адрес"
        disabled={disabled}
      />
      <TextField
        value={postAddress}
        onChange={e => onChange("postAddress", e.target.value)}
        label="Почтовый адрес"
        disabled={disabled}
      />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            value={email}
            onChange={e => onChange("email", e.target.value)}
            label="Email"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={phones}
            onChange={e => onChange("phones", e.target.value)}
            label="Контактные телефоны"
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(AddOrganizationForm);
